<template>
	<div class="standardDispose ">
		<div class="itemTitleBox disBetween">
			<div class="disStart">
				<span class="title">活动管理</span>
			</div>
			<div class="icon_add iconBox" @click="itemClick({})" title="新增活动"></div>
		</div>
		<div class="BtnBox disBetween">
			<div class="searchBox disBetween">
				<div class="myinputBox">
					<el-input clearable v-model="searchObj.communityName" placeholder="请输入社区名称"></el-input>
					<!-- <el-select clearable v-model="searchObj.communityId" filterable remote reserve-keyword
						placeholder="请输入社区关键词" :remote-method="remoteMethod" @change="changeSelect">
						<el-option v-for="item in restaurants" :key="item.communityId" :label="item.communityName"
							:value="item.communityId">
						</el-option>
					</el-select> -->
				</div>
				<div class="myinputBox">
					<!--  -->
					<el-cascader clearable ref="cascader1" v-model="areaValue"
						:props="{ value: 'areaCode',label: 'areaName',children: 'childList'}" :options="areaList"
						@change="handleChange($event,1)" placeholder="请选择所在地区">
					</el-cascader>
				</div>
				<div class="myinputBox myinputBox5">
					<el-date-picker  v-model="searchObj.startTime" value-format="yyyy-MM-dd" type="date"
						placeholder="开始时间">
					</el-date-picker>
				</div>
				<div class="myinputBox myinputBox5">
					<el-date-picker v-model="searchObj.endTime" value-format="yyyy-MM-dd" type="date"
						placeholder="结束时间">
					</el-date-picker>	
				</div>
				<el-button type="success" @click="toSearch">查询</el-button>
			</div>

		</div>
		<div class="listBox">
			<div style="height: 100%;width: 100%;" v-loading="loading">
				<div class="content myTable">
					<el-table :data="tableData" stripe style="width: 100%">
						<el-table-column type="index" label="序号" width="60">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="amountActivityName" label="活动名称" >
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="areaName" label="活动地区" width="120">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityName" label="活动社区" >
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="activityStatus" label="活动状态" >
							<template slot-scope="scope">
								<span v-if="scope.row.activityStatus==1">未开始</span>
								<span v-if="scope.row.activityStatus==2">进行中</span>
								<span v-if="scope.row.activityStatus==3">已结束</span>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="activityStartTime" label="开始时间">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="activityEndTime" label="结束时间">
						</el-table-column>
						<el-table-column prop="operate" label="操作" width="60">
							<template slot-scope="scope">
								<el-button v-if="scope.row.activityStatus==1" type="text" size="small"
									@click="itemClick(scope.row,1)">编辑</el-button>
								<el-button v-else type="text" size="small"
									@click="itemClick(scope.row,2)">详情</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="pagination  mypagination">
					<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
						:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
						layout="total, prev, pager, next,jumper" ref="pagination"
						@current-change="handleCurrentChange($event,1)">
					</el-pagination>
				</div>
			</div>

		</div>
		<el-dialog title="活动社区" center class="mydialog2" :close-on-click-modal="NOfalse" :visible.sync="dialogDispose"
			width="60%">
			<div class="dialogBox dialogBox2">
				<div class="disposeBox disBetween">
					<div class="disposeLeft">
						<div class="choiceBox">选择地区</div>
						<div class="moduleList">
							<el-tree highlight-current :props="props2" :load="loadNode" lazy @node-click="nodeClick	">
							</el-tree>
						</div>
					</div>
					<div class="linBox"></div>
					<div class="disposeRight">
						<div class="choiceBox">社区名称</div>
						<div class="moduleList">
							<div v-for="(item,inx) in menuList" :key="inx" class="itemBox disStart">
								<span class="titleBox">{{item.communityName}}</span>
								<el-checkbox v-model="item.checkFlag" @change="menuClick($event,item,inx)">
								</el-checkbox>
							</div>
						</div>
					</div>
				</div>
				<div slot="footer" class="dialog-footer diabtnBox disAround">
					<el-button @click="dialogDispose = false">取 消</el-button>
					<el-button type="primary" @click="savedialogDispose">确 定</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog :title="dialogTitle" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="dialogVisible" width="60%">
			<div class="dialogBox">
				<el-form :model="itemObj" :rules="rules" ref="ruleForm3" label-width="100px" class="demo-ruleForm">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="活动社区" prop="amountActivityName">
								<div class="myinputBox lastchoiceBox disStart" >
									<div class="communityList ellipsis">
										<span v-for="(item,inx) in itemObj.communityIdList.slice(0,3)" class="community">{{item.communityName}}</span>
									</div>
									<span class="choice" @click="dialogDispose=true">选择社区</span>
									<!-- 已选择communityIdList -->
									<!-- <el-cascader clearable ref="cascader1" :props="props" v-model="areaValue"
										@change="handleChange($event,1)" placeholder="请选择所在地区">
									</el-cascader> -->
									<!-- <el-select clearable multiple v-model="itemObj.search" filterable remote
										reserve-keyword placeholder="请输入社区关键词" :remote-method="remoteMethod"
										@change="changeSelect">
										<el-option v-for="item in restaurants" :key="item.communityName"
											:label="item.communityName" :value="item.communityName">
										</el-option>
									</el-select> -->
								</div>
							</el-form-item>
						</div>
						<!-- <div class="diaTpye disStart">
							<el-form-item class="lableBox" label="活动名称" prop="amountActivityName">
								<div class="myinputBox">
									<el-cascader clearable ref="cascader1"
										:props="{ value: 'areaCode',label: 'areaName',children: 'childList',multiple:true}"
										v-model="areaValue" :options="areaList" @change="handleChange($event,1)"
										placeholder="请选择所在地区">
									</el-cascader>
								</div>
							</el-form-item>
						</div> -->
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="活动名称" prop="amountActivityName">
								<div class="myinputBox">
									<el-input clearable :disabled="disabled" v-model="itemObj.amountActivityName"
										placeholder="请输入活动名称">
									</el-input>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="活动日期" prop="timeData">
								<div class="myinputBox myinputBox2">
									<!-- <el-date-picker value-format="yyyy-MM-dd" v-model="itemObj.activityStartTime"
										type="date" placeholder="选择日期">
									</el-date-picker> -->
									<el-date-picker v-model="itemObj.timeData" type="datetimerange" :disabled="disabled"
										value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期"
										end-placeholder="结束日期">
									</el-date-picker>
								</div>
							</el-form-item>
						</div>
						<!-- <div class="diaTpye disStart">
							<el-form-item class="lableBox" label="结束日期" prop="activityEndTime">
								<div class="myinputBox">
									<el-date-picker value-format="yyyy-MM-dd" v-model="itemObj.activityEndTime"
										type="date" placeholder="选择日期">
									</el-date-picker>
								</div>
							</el-form-item>
						</div> -->
					</div>
				</el-form>
				<div class="titleBox">活动配置</div>
				<div class="itemBox disStart" v-for="(item,inx) in itemObj.amountActivitySetList" :key="inx">
					<el-checkbox :disabled="disabled" v-model="item.checked">惠</el-checkbox>
					<div class="nameBox">配置{{inx+1}}</div>
					<div class="numItem numItem1 disStart">
						<div class="lableBox">充值金：</div>
						<div class="inputBox">
							<el-input v-model="item.moneyAmount" :disabled="disabled" type="Number"
								placeholder=""></el-input>
						</div>
						<div class="unitBox">元</div>
					</div>
					<div class="numItem disStart">
						<div class="lableBox">到账充值金：</div>
						<div class="inputBox">
							<el-input v-model="item.coinAmount" :disabled="disabled" type="Number"
								placeholder=""></el-input>
						</div>
						<div class="unitBox">元</div>
					</div>
					<div class="numItem disStart">
						<div class="lableBox">到账赠送金：</div>
						<div class="inputBox">
							<el-input v-model="item.extraCoinAmount" :disabled="disabled" type="Number"
								placeholder=""></el-input>
						</div>
						<div class="unitBox">元</div>
					</div>
					<div class="btnBox disStart" v-if="disabled==false">
						<span class="delIcon" @click="btnClick(item,inx,1)"></span>
						<span class="addIcon" v-if="inx==itemObj.amountActivitySetList.length-1"
							@click="btnClick(item,inx,2)"></span>
					</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer diabtnBox disAround" v-if="disabled==false">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="toSave('ruleForm3')">确 定</el-button>
			</div>
			<div slot="footer" class="dialog-footer diabtnBox disAround" v-else>
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	import ajax from '../../../../../../common/js/ajax.js' //引用封装好的axios
	var token = localStorage.getItem('token')
	let self = this
	export default {
		name: "standardDispose",
		components: {
		},
		props: {
			disposeList: {
				type: Array,
				default: []
			},
		},
		data() {
			return {
				dialogDispose: false,
				menuList: [],
				saveArr:[],
				props2: {
					label: 'areaName',
					value: "areaCode",
					isLeaf: 'leaf'
				},
				props: {
					multiple: true,
					checkStrictly: true,
					lazy: true,
					lazyLoad(node, resolve) {
						console.log(node)
						let params = {
							parentAreaCode: node.value || ""
						}
						ajax('amountActivity/listAreaInfoAndCommunity', params, 'post').then((res) => {
							if (res.returnCode == 200) {
								if (res.obj.type == 1) {
									let arr = []
									for (let item of res.obj.list) {
										arr.push({
											value: item.areaCode,
											label: item.areaName,

										})
									}
									console.log(arr)
									resolve(arr)
								} else {
									let arr = []
									for (let item of res.obj.list) {
										arr.push({
											value: item.communityId,
											label: item.communityName,
											leaf: true
										})
									}
									console.log(arr)
									resolve(arr)
								}

							}

						})
					}
				},
				str: "设备",
				PageInfo: {
					pagesize: 10,
					pagenum: 1,
					total: 0
				},
				searchObj: {
					pageNo: 1, //当前页
					pageSize: 10, //当前页个数
					communityId: ""
				},
				tableData: [{
					name: "2343434"

				}],
				NOfalse: false,
				disabled: false,
				dialogTitle: "新增活动",
				dialogVisible: false,
				loading: false,
				itemObj: {
					amountActivitySetList: [],
					communityIdList:[],
					amountActivityName: "",
					activityStartTime: "",
					activityEndTime: ""
				},
				rules: {
					amountActivityName: [{
						required: true,
						message: '请输入活动名称',
						trigger: 'blur'
					}],
					timeData: [{
						required: true,
						message: '请选择开始日期',
						trigger: 'change'
					}]
				},
				areaValue: "",
				areaList: [],
				myArr: [],
				restaurants: [],
			}
		},
		mounted() {
			this.getData()
			this.getArr()
			this.$nextTick(() => {
				if (!(localStorage.getItem("areaList"))) {
					this.getAreaList()
				} else {
					this.$set(this, "areaList", JSON.parse(localStorage.getItem("areaList")))
				}
			})
		},
		methods: {
			nodeClick(n,m,l){
				if(n.leaf){
					this.saveArr=this.itemObj.communityIdList
					this.$api.listAreaInfoAndCommunity({parentAreaCode:n.areaCode}).then((res)=>{
						console.log(res)
						for(let j of res.obj.list){
							this.$set(j,"checkFlag",false)
							for(let k of this.itemObj.communityIdList){
								if(j.communityId==k.communityId){
									console.log(j)
									this.$set(j,"checkFlag",true)
								}
							}
						}
						// for(let k of this.itemObj.communityIdList){
						// 	for(let j of res.obj.list){
						// 		this.$set(j,"checkFlag",false)
						// 		if(j.communityId==k.communityId){
						// 			this.$set(j,"checkFlag",true)
						// 		}
						// 	}
						// }
						console.log(this.menuList)
						this.$set(this,"menuList",res.obj.list)
					})
				}
			},
			loadNode(node, resolve) {
				let id = ""
				if (node.data) {
					// if()
					id = node.data.areaCode
				}

				this.$api.listAreaInfoAndCommunity({
					parentAreaCode: id
				}).then((res) => {
					if (res.returnCode == 200) {
						if (res.obj.type == 1) {
							for (let k of res.obj.list) {
								if (node.level == 1) {
									if (node.data.areaName == "北京市" || node.data.areaName ==
										"天津市" ||
										node.data.areaName == "上海市" || node.data.areaName == "重庆市" || node.data
										.areaName == "香港特别行政区" || node.data
										.areaName == "澳门特别行政区") {
										k.leaf = true
									}
								} else if (node.level == 2) {
									k.leaf = true
								}
							}
							return resolve(res.obj.list)
						} 
					}
				})
			},
			savedialogDispose(){
				this.dialogDispose=false
				this.$set(this.itemObj,"communityIdList",this.saveArr)
				// this.$set(this,"saveArr",[])
			},
			menuClick(e, item, inx,) {
				this.$nextTick(() => {
					// console.log(e)
					// console.log(item)
					// console.log(inx)
					console.log(this.menuList)
					if(e==false){
						let index= this.saveArr.findIndex((res)=>{
							return res.communityId==item.communityId
						})
						if(index != -1){
							this.saveArr.splice(index,1)
						}
					}else{
						this.saveArr.push(item)
					}
					this.$set(this.itemObj,"communityIdList",this.saveArr)
					// let index = this.menuList[this.active].children.findIndex((res) => {
					// 	return res.checkFlag == true
					// })
					// if (index != -1) {
					// 	console.log(this.itemObj.communityIdList)
					// 	this.$set(this.menuList[this.active], "checkFlag", true)
					// } else {
					// 	this.$set(this.menuList[this.active], "checkFlag", false)
					// }
				})
			},
			getArr() {
				this.$api.listAreaInfoAndCommunity({
					parentAreaCode: ""
				}).then((res) => {

				})
			},
			toSearch() {
				this.$set(this.PageInfo, "pagenum", 1)
				this.$set(this.searchObj, "pageNo", 1)
				this.getData()
			},
			getAreaList() {
				this.$api.listAllAreaInfo().then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "areaList", res.obj)
						localStorage.setItem('areaList', JSON.stringify(res.obj))
					}
				})
			},
			remoteMethod(query) {
				let that = this
				if (query !== '') {
					let searchObj = {
						search: query,
						pageNo: 1, //当前页
						pageSize: 1000, //当
						provinceCode: "", //省级编号
						cityCode: "", //市级编号
						areaCode: "" //区级编号
					}
					that.$api.listCommunityInfo(searchObj).then((res) => {
						if (res.returnCode == 200) {
							that.$set(that, "restaurants", res.obj.list)
							setTimeout(() => {
								that.options = that.restaurants.filter(item => {
									return item.communityName.toLowerCase()
										.indexOf(query.toLowerCase()) > -1;
								});
							}, 200);

						}
					})

				} else {
					this.options = [];
				}
			},
			changeSelect(n) {
				console.log(n)
			},
			handleChange(value, n) {
				console.log(value)
				let nodesInfo = this.$refs['cascader' + n].getCheckedNodes()
				if (nodesInfo.length > 0) {
					this.$set(this.searchObj, "provinceCode", nodesInfo[0].path[0] || "")
					this.$set(this.searchObj, "cityCode", nodesInfo[0].path[1] || "")
					this.$set(this.searchObj, "areaCode", nodesInfo[0].path[2] || "")
				} else {
					this.$set(this.searchObj, "provinceCode", "")
					this.$set(this.searchObj, "cityCode", "")
					this.$set(this.searchObj, "areaCode", "")
				}
			},
			handleSelect(item) {

				this.$set(this.creatObj, "equipmentServiceProvider", item.value)
			},
			getData() {
				this.loading = true
				this.$api.listAmountActivity(this.searchObj).then((res) => {
					if (res.returnCode == 200) {
						this.loading = false
						this.$set(this, "tableData", res.obj.list || [])
						this.$set(this.PageInfo, "total", res.obj.total || 0)
					} else {
						this.loading = false
						this.$message({
							message: res.returnMessage || "请求异常",
							type: 'error'
						});
					}
				})
			},
			itemClick(item, n) {
				let that = this
				// if (n == 2) {
				// 	this.disabled = true
				// } else {
				// 	this.disabled = false
				// }
				// this.disabled = false
				if (item.amountActivityId) {
					this.$api.selectAmountActivity({
						amountActivityId: item.amountActivityId
					}).then((res) => {
						if (res.returnCode == 200) {
							res.obj.timeData = [res.obj.activityStartTime, res.obj.activityEndTime]
							for (let k of res.obj.amountActivitySetList) {
								k.checked = k.preferentialFlag == 2 ? true : false
							}
							this.$nextTick(() => {
								this.$set(this, "itemObj", res.obj)
							})
						}
					})
					this.dialogTitle = "活动编辑"

				} else {
					this.$set(this, "itemObj", {
						amountActivityName: "",
						activityStartTime: "",
						activityEndTime: "",
						communityIdList:[],
						amountActivitySetList:this.disposeList
					})
					this.dialogTitle = "新增活动"
				}
				this.dialogVisible = true
				this.$nextTick(() => {
					this.$refs.ruleForm3.clearValidate()
				})

			},
			// 按钮保存 新增/编辑
			toSave(formName) {
				let that = this
				if(this.itemObj.communityIdList.length<=0){
					this.$message({
						message: '请选择活动社区',
						type:"info"
					});
					return false
				}
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.dialogTitle == "新增活动") {
							this.addAmountActivity()
						} else {
							this.updateAmountActivity()
						}
					} else {
						return false;
					}
				});
			},
			addAmountActivity() {

				let obj = {
					amountActivityName: this.itemObj.amountActivityName,
					activityStartTime: this.itemObj.timeData[0],
					activityEndTime: this.itemObj.timeData[1],
					activityStatus: this.itemObj.activityStatus || 1,
					amountActivitySetList: [],
					communityIdList:[]
				}
				for(let j of this.itemObj.communityIdList){
					obj.communityIdList.push(j.communityId)
				}
				for (let k of this.itemObj.amountActivitySetList) {
					obj.amountActivitySetList.push({
						moneyAmount: k.moneyAmount, //充值金额
						coinAmount: k.coinAmount, //充值金
						extraCoinAmount: k.extraCoinAmount, //赠送金
						preferentialFlag: k.checked ? 2 : 1 //是否优惠 1不优惠 2优惠
					})
				}
				this.$api.addAmountActivity(obj).then((res) => {
					if (res.returnCode == 200) {
						this.$nextTick(() => {
							this.dialogVisible = false
							this.$message({
								message: '新增活动成功',
								type: 'success'
							});
							setTimeout(() => {
								this.getData()
							}, 500)
						})
					}
				})
			},
			updateAmountActivity() {
				let obj = {
					amountActivityName: this.itemObj.amountActivityName,
					amountActivityId: this.itemObj.amountActivityId,
					activityStartTime: this.itemObj.timeData[0],
					activityEndTime: this.itemObj.timeData[1],
					// activityStatus: 3,
					amountActivitySetList: [],
					communityIdList:[]
				}
				for(let j of this.itemObj.communityIdList){
					obj.communityIdList.push(j.communityId)
				}
				for (let k of this.itemObj.amountActivitySetList) {
					obj.amountActivitySetList.push({
						moneyAmount: k.moneyAmount, //充值金额
						coinAmount: k.coinAmount, //充值金
						extraCoinAmount: k.extraCoinAmount, //赠送金
						preferentialFlag: k.checked ? 2 : 1 //是否优惠 1不优惠 2优惠
					})
				}
				this.$api.updateAmountActivity(obj).then((res) => {
					if (res.returnCode == 200) {
						this.$nextTick(() => {
							this.dialogVisible = false
							this.$message({
								message: '修改活动成功',
								type: 'success'
							});
							setTimeout(() => {
								this.getData()
							}, 500)
						})
					}
				})
			},
			btnClick(item, inx, n) {
				if (n == 1) {
					if (this.itemObj.amountActivitySetList.length == 1) {
						this.$message({
							type: 'warning',
							message: '最少保存一个标准配置!'
						});
						return false
					}
					let that = this
					this.$confirm('是否确认删除该配置项?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.itemObj.amountActivitySetList.splice(inx, 1)
						that.$message({
							type: 'success',
							message: '删除成功!'
						});


					}).catch(() => {

					});
				} else {
					this.itemObj.amountActivitySetList.push({
						name: "配置",
						value1: "",
						value2: "",
						type: "1"
					})
				}
			},
			// 选择分页
			handleCurrentChange(val) {
				this.$set(this.PageInfo, "pagenum", val)
				this.$set(this.searchObj, "pageNo", val)
				this.getData({})
			},
			openDia() {}
		}
	}
</script>

<style lang="scss" scoped>
	@import "./standardDispose.scss"
</style>